import { useQuery } from 'react-query';
import { useAxios } from 'shared/hooks';
export var useAppointmentsMeasures = function (members, enabled) {
    var axios = useAxios();
    var joinedMembers = "member_id[]=".concat(members.join('&member_id[]='));
    return useQuery(['mbc-get-assessments', joinedMembers], function () {
        return axios.get("/api/v1/mbc/assessments?".concat(joinedMembers, "&kind[]=initial_assessment&kind[]=conditions_check_in&kind[]=progress_update&kind[]=goal_check_in"));
    }, {
        select: function (response) { return response === null || response === void 0 ? void 0 : response.data.data; },
        enabled: enabled,
    });
};
